import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CContainer, CSpinner } from '@coreui/react';
import { withFirebase } from 'src/views/firebase';
import routes from '../routes';

// Page loading fallback with centered spinner
const PageLoadingFallback = () => (
  <div 
    className="d-flex flex-column justify-content-center align-items-center" 
    style={{ minHeight: '400px' }}
  >
    <CSpinner color="primary" style={{ width: '3rem', height: '3rem' }} />
    <p className="mt-3 mb-2">Loading...</p>
  </div>
);

const AppContent = () => {
  return (
    <CContainer lg className="app-copy-electric">
      <Suspense fallback={<PageLoadingFallback />}>
        <Routes>
          {routes.map((route, idx) => (
            route.element && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={<route.element />}
              />
            )
          ))}
          <Route path="/" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  );
}

export default withFirebase(React.memo(AppContent));


